<template lang="html">
    <!-- https://bootstrapious.com/p/bootstrap-sidebar -->
    <div class="c_container">
      <!-- Sidebar -->
      <nav id="sidebar">
        <div class="sidebar-header">
             <h3>Codoc</h3>
         </div>
         <ul class="list-unstyled components sidebar-components-list">
             <router-link to="/codocs/all" :tag="'li'">
               <a><i class="fas fa-clipboard-list"></i>All Codocs</a>
             </router-link>
             <router-link to="/user" :tag="'li'">
               <a><i class="fas fa-user-circle"></i>John Smith (@johnsmith)</a>
             </router-link>
             <li class="sidebar-list-subheader">Repositories</li>
             <router-link to="/repo/demo123" :tag="'li'" class="active">
               <a><i class="fas fa-code-branch"></i> facebook/react</a>
             </router-link>
             <li class="sidebar-list-subheader">Starred</li>
             <router-link to="/repo/demo123" :tag="'li'">
               <a><i class="fas fa-file-alt"></i>react/ (Getting Started...)</a>
             </router-link>
             <router-link to="/repo/demo123" :tag="'li'">
               <a><i class="fas fa-file-alt"></i>react/scripts/</a>
             </router-link>

             <!-- <li class="sidebar-list-subheader">Other</li> -->
             <li class="sidebar-list-subheader"></li>
             <li>
                 <a href="#">Logout</a>
             </li>
         </ul>
      </nav>

      <!-- Page Content -->
      <div id="content">
        <div class="container-fluid demo-content-container">
          <div class="row">
            <div class="col-sm-6 codep-col">
              <nav class="navbar navbar-expand-lg navbar-light bg-light" v-if="false">
                  <div class="container-fluid">
                      <button type="button" id="sidebarCollapse" class="btn btn-info">
                          <i class="fas fa-align-left"></i>
                          <span>Toggle Sidebar</span>
                      </button>
                  </div>
              </nav>
              <div class="codep-header">
                <h4>facebook/react</h4>
                <!-- <i class="fab fa-github-square"></i>
                <a href="https://github.com/facebook/react">facebook/react</a>-->
              </div>
              <div class="codep-body">
                <div class="codep-body__file">/ (root)</div>
                <div class="codep-body__filecontainer">
                  <div class="filerow" v-for="rfile in rfiles">
                    <span class="fr-expand"></span>
                    <span class="fr-icon">
                      <i class="fas fa-folder"  v-if="rfile.type=='folder'"></i>
                      <i class="fas fa-file-alt"  v-if="rfile.type=='file'"></i>
                    </span>
                    <span class="fr-name text-truncate"><a href="#">{{rfile.name}}</a></span>
                    <span class="fr-desc text-truncate">{{rfile.desc}}</span>
                    <span class="fr-codoc"><span v-if="rfile.hasCodoc==true"><i class="fas fa-clipboard-list"></i> Codoc</span></span>
                    <span class="fr-edited"> {{rfile.lastEdited }}</span>
                  </div>
                </div>
              </div>
              <div class="codep-file">
                <div class="codep-file__header">
                  <h4>package.json</h4>
                  <div>Configuration for NPM, includes metadata about React node package.</div>
                </div>
                <div class="codep-file__body">
                  <quill-editor v-model="codeContent"
                    ref="codeQuillEditor"
                    :options="codeEditorOption"
                    :disabled='disabled'>
                  </quill-editor>
                </div>
              </div>
            </div>
            <div class="col-sm-6 docm-col">
              <div class="docm-content">
                <!-- https://dribbble.com/shots/5819152-OpenNode-Documentation -->
                <div class="docm-col__header">
                  <h5>/ (root)</h5>
                  <div class="btn btn-sm btn-info btn-docm-save">Save Changes</div>
                </div>
                <quill-editor v-model="content"
                              ref="myQuillEditor"
                              :options="editorOption"
                              @blur="onEditorBlur($event)"
                              @focus="onEditorFocus($event)"
                              @ready="onEditorReady($event)">
                </quill-editor>
                <div class="docm-footer" v-if="false">
                  <div class="btn btn-lg btn-info btn-docm-save">Save Changes</div>
                  <div class="form-check" v-if="false">
                   <input class="form-check-input" type="checkbox" value="" id="defaultCheck1">
                   <label class="form-check-label" for="defaultCheck1">Also update README.md
                   </label>
                  </div>
                </div>
              </div>
              <!-- We'll fill this with dummy content -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/*
import {firebase, firebaseui, firebaseuiConfig, firestoreDB} from '@/common/firebaseConfig.js'
import { getReminderContacts, getRecentContacts } from '@/common/restUtils.js'
import AccountCard from '@/components/AccountCard.vue'
import ContactCard from '@/components/ContactCard.vue'
import ContactCardMobile from '@/components/ContactCardMobile.vue'
import PostEditor from '@/components/PostEditor.vue'
import NewContactModal from '@/components/NewContactModal.vue'
import NewMeetingModal from '@/components/NewMeetingModal.vue'
// import PostsFeed from '@/components/PostsFeed.vue'
import ContactDetailModal from '@/components/ContactDetailModal.vue'
import OnboardingModal from '@/components/OnboardingModal.vue' */
import _ from 'lodash';
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css';
const axios = require('axios');
const showdown  = require('showdown'); // TODO: Move this into Pandoc and int a server

import { quillEditor } from 'vue-quill-editor'

export default {
  components: {
    quillEditor
  },
  data: function () {
   return {
      mdData: '',
      htmlData: '',
      content: '',
      codeContent: '',
      rfiles: [
        {
          type: 'folder',
          hasCodoc: true,
          name: '.circleci',
          desc: 'Contains config for CircleCI build',
          lastEdited: '6 months ago'
        },
        {
          type: 'folder',
          hasCodoc: true,
          name: '.github',
          desc: 'Guide for github contributions',
          lastEdited: '6 months ago'
        },
        {
          type: 'folder',
          hasCodoc: true,
          name: 'fixtures',
          desc: 'Contains fixtures (common / mock components) for testing',
          lastEdited: '6 months ago'
        },
        {
          type: 'folder',
          hasCodoc: true,
          name: 'packages',
          desc: 'Contains packages (e.x. react-dom) used internally',
          lastEdited: '6 months ago'
        },
        {
          type: 'file',
          hasCodoc: false,
          name: '.babelrc',
          desc: 'Config file for babel',
          lastEdited: '6 months ago'
        },
        {
          type: 'file',
          hasCodoc: false,
          name: '.editorconfig',
          desc: 'Coding confguration for your IDE',
          lastEdited: '6 months ago'
        },
        {
          type: 'file',
          hasCodoc: false,
          name: '.eslintrc.js',
          desc: 'Linting config for ESLint',
          lastEdited: '6 months ago'
        },
        {
          type: 'file',
          hasCodoc: false,
          name: '.gitattributes',
          desc: '',
          lastEdited: '6 months ago'
        },
        {
          type: 'file',
          hasCodoc: false,
          name: '.gitignore',
          desc: '',
          lastEdited: '6 months ago'
        },
        {
          type: 'file',
          hasCodoc: false,
          name: '.mailmap',
          desc: 'List of React contributors',
          lastEdited: '6 months ago'
        },
      ],
      editorOption: {
        formats: ['bold', 'code', 'italic', 'link', 'script', 'underline', 'blockquote', 'header', 'indent', 'list', 'align', 'code-block', 'image', 'video'],
        placeholder: 'Describe what is in \/react...',
        theme: 'snow',
        modules: {
          toolbar: [
            [{ 'header': 1 }, { 'header': 2 }],
            // [{ 'header': [1, 2, 3, 4, false] }, ],
            // ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            // 'code',
            [ 'code-block', 'blockquote', 'link'],
            // [{ 'header': 1 }, { 'header': 2 }],               // custom button values
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            // [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
            // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            // ['clean']                                         // remove formatting button
          ]
        }
      },
      disabled: true,
      codeEditorOption: {
        // formats: ['bold', 'code', 'italic', 'link', 'script', 'underline', 'blockquote', 'header', 'indent', 'list', 'align', 'code-block', 'image', 'video'],
        // placeholder: 'Describe what is in \/react...',
        theme: 'bubble',
        readOnly: true,
        modules: {
          syntax: true,              // Include syntax module
        }
      }
   }
 },
  mounted: function () {
    // Make a request for a user with a given ID
    console.log("Mounted");
    axios.get('https://raw.githubusercontent.com/facebook/react/master/README.md')
      .then((response) => {
        // handle success
        console.log("mounted", response);
        // console.log("mounted", response['data']);
        this.mdData = response['data'];
        var converter = new showdown.Converter();
        this.htmlData = converter.makeHtml(this.mdData);
        this.content = this.htmlData;
        //console.log(this.htmlData);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      });

    fetch('https://raw.githubusercontent.com/facebook/react/master/package.json')
      .then((response) => {
        return response.text();
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then((responseTest) => {
        console.log("second responseText", responseTest);
        this.codeContent = '<pre>'+responseTest+'</pre>';
      })

  },
  computed: {
    filteredContactsData: function () {
    }
  },
  methods: {
    // TODO: https://patleeman.github.io/quill-markdown-shortcuts/
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill)
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }) {
      console.log('editor change!', quill, html, text)
      this.content = html
    }
    /*
    openContactDetailModal: function (contactData) {
      this.$root.$emit('contactDetailModalData', contactData);
      this.$modal.show('contact-detail-modal', {contactData: contactData, mode: 'activity', contactIndex: this.contactIndex});
    },*/
  }
}

</script>

<style lang="scss">
.c_container {
  width: 100%;
  // overflow: hidden;  /*makes the body non-scrollable (we will add scrolling to the sidebar and main content containers)*/
  margin: 0px;  /*removes default style*/
  display: flex;  /*enables flex content for its children*/
  box-sizing: border-box;
  align-items: stretch;
}
.demo-content-container {
  // min-width: 1100px;
}
#sidebar {
    min-width: 250px;
    max-width: 250px;
    min-height: 100vh;
}

#sidebar.active {
    margin-left: -250px;
}

.docm-col {
  //background-color: #f4f6f9;
  background-color: #2B3641;
  border-left: 1px solid #eee;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .docm-content {
    padding: 15px;

  }
  .docm-col__header {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    padding: 10px;
    background-color: lighten(#2B3641, 10%);
    color: #fff;
    opacity: 6;
    display: flex;
    .btn-docm-save {
      align-items: flex-end;
      margin-left: auto;
    }
  }
  h5 {
    // margin-top: 1em;
    // border-bottom: 1px solid #eee;
    // padding-bottom: .5rem;
    font-size: 1.2rem;
  }
  .quill-editor {
    background-color: #fff;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;

    .ql-toolbar.ql-snow {
      opacity: .8;
      border: none;
      border-bottom: 1px solid #aaa;
    }
    .ql-editor {
      min-height: 250px;
      max-height: 80vh;
      // overflow scrolls
    }
    .ql-container {
      border: none;
    }
  }
  .docm-footer {
    margin-top: 1rem;
    padding: 20px 20px 30px 20px;
    // padding-bottom: 50px;
    // border-top: 1px solid #aaa;
    display: inline-block;
    align-self: flex-end;
    margin-top: auto;
    width: 100%;
    .btn-docm-save {
      width: 100%;
      font-weight: 300;
      margin-bottom: .5rem;
    }
  }
}

.codep-body__file {
  background-color: #f1f8ff;
  border: 1px solid #c8e1ff;
  color: #586069;
  font-size: 13px;
  line-height: 20px;
  margin-bottom: -1px;
  padding: 10px;
  position: relative;
}

.codep-body__filecontainer {
  border: 1px solid #dfe2e5;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  border-top: 0;
  margin-bottom: 10px;
}

.filerow {
  padding: 6px 3px;
  white-space: nowrap;
  border-top: 1px solid #eaecef;
  line-height: 20px;
  display: flex;
  // align-items: stretch;
  align-content: space-between;
  .fr-expand, .fr-name, .fr-codoc {
    margin-right: 6px;
  }
  .fr-expand {
      height: 16px;
      min-width: 16px;
  }
  .fr-icon {
    color: #70A3CB;
    min-width: 16px;
    margin-right: 2px;
  }
  .fr-name {
    min-width: 70px;
    max-width: 100px;
  }
  .fr-desc {
    min-width: 80px;
    margin-right: 10px;
    flex-grow: 1;
    flex-shrink: 10000; // super hacky but we can get back to this
  }
  .fr-codoc {
    min-width: 20px;
    color: #70A2C8;
    padding: 0px 15px;
  }
  .fr-edited {
    padding-right: 10px;
    min-width: 80px;
    align-self: flex-end;
    margin-left: auto;
  }
}
.codep-header {
  h4 {
    margin-top: 1.5rem;
    margin-bottom: .5rem;
  }
}
.codep-file {
  background-color: #fff;
  border: 1px solid #d1d5da;
  border-radius: 3px;
  .codep-file__header {
    padding: 8px 16px;
    display: flex;
    background-color: #f6f8fa;
    border: 1px solid #d1d5da;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    margin: -1px -1px 0;
    flex-direction: column;
    h4 {
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 0px;
    }
  }
  .codep-file__body {
    padding: 8px 16px;
  }
}
/*
a[data-toggle="collapse"] {
    position: relative;
}

.dropdown-toggle::after {
    display: block;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
}
*/
</style>

<style lang="scss">

@media (max-width: 768px) {
    /*
    #sidebar {
        margin-left: -250px;
    }
    #sidebar.active {
        margin-left: 0;
    }*/
    /* TODO: Revisit responsiveness for the sidebar beyond the demo */
    .docm-col {
      min-height: 300px;
    }
}

</style>
